module.exports = __webpack_public_path__ + "img/chevron-left-alt.200bb073.svg";